module.exports = __webpack_public_path__ + "img/openeden.a13f582e.svg";